<template>
  <div>
    <div v-if="init">
      <purchases :id="order.id" :order="order" />
      <promotions :order="order" :partner="partner" />
      <div class="border" v-if="validate === true">
        <div>
          <div class="mb-3">
            <h4>
              IMEI устройств

              <info :id="1" />
            </h4>
            <div>
              <div
                class="mb-2"
                v-for="(purchase, index) in purchases"
                :key="index"
                v-show="purchase.is_device === true"
              >
                <label>{{
                  `${index + 1}. IMEI устройства - ${purchase.name}`
                }}</label>
                <input
                  class="form-control"
                  type="text"
                  maxlength="15"
                  v-mask="'###############'"
                  v-model="purchases[index]['imei']"
                />
              </div>
            </div>

            <hr />

            <h4>
              {{
                "select_period_credit" | setText("Выберите период рассрочки")
              }}
            </h4>

            <div class="mt-2">
              <ul v-if="!partnerConditionLoading">
                <li v-for="(conditional, index) in conditionals" :key="index">
                  <div
                    v-if="conditional.partnerCond.month"
                    class="conditional-selector"
                  >
                    <h4 class="text-info m-0">
                      Срок: {{ conditional.partnerCond.month }}
                      {{ "mo" | setText }}
                    </h4>

                    <div>
                      Выделенный лимит на покупку:
                      {{ conditional.cond.balance | spaceBetweenNumber }}
                      UZS
                    </div>
                    <div>
                      Оплата в месяц:
                      <!-- {{
                        Math.round(
                          (order.price_total +
                            (conditional.partnerCond.coefficient / 100) *
                              order.price_total) /
                            conditional.partnerCond.month
                        ) | spaceBetweenNumber
                      }} -->
                      {{ conditional.cond.month | spaceBetweenNumber }}
                      UZS
                    </div>
                    <div class="mt-2">
                      <b>
                        Итого:
                        <!-- {{
                          Math.round(
                            order.price_total +
                              (conditional.partnerCond.coefficient / 100) *
                                order.price_total
                          ) | spaceBetweenNumber
                        }} -->
                        {{ conditional.cond.total | spaceBetweenNumber }}
                        UZS
                      </b>
                    </div>
                    <div>
                      <button
                        @click="addOrder(conditional)"
                        :class="`btn btn-success btn-sm mt-3`"
                      >
                        Выбрать условие
                      </button>
                    </div>
                  </div>
                </li>
              </ul>

              <div v-else class="text-left text-danger">
                <h4>Ожидайте. Идет расчет рассрочки...</h4>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        <h3 class="text-danger">
          {{ "order_error" | setText("Заказ не проходит условию") }}
        </h3>
        <h5>
          {{ "min_price_partner" | setText(" Минимальная цена заказа") }}:
          {{ partner.min_price | spaceBetweenNumber }} UZS
        </h5>
        <h5>
          {{ "max_price_partner" | setText(" Максимальная цена заказа") }}:
          {{ partner.max_price | spaceBetweenNumber }} UZS
        </h5>
        <h5>
          {{ "min_qty_partner" | setText("Минимальное количество товаров") }}:
          {{ partner.min_amount_product | spaceBetweenNumber }} шт.
        </h5>
        <h5>
          {{ "max_qty_partner" | setText("Максимальное кличество товаров") }}:
          {{ partner.max_amount_product | spaceBetweenNumber }} шт.
        </h5>
      </div>
    </div>
  </div>
</template>
<script>
import Purchases from "@/components/Item/Order/Purchases";
import Promotions from "@/components/Item/Order/Promotions";
import { logger, errorNotify } from "../../../plugins/functions";
export default {
  components: {
    Purchases,
    Promotions,
  },
  computed: {
    conditionals() {
      let mergedArray = [];
      for (const item1 of this.partnerConditions) {
        for (const item2 of this.uzumConditionals) {
          if (item1.period_months == item2.month) {
            mergedArray.push({ cond: item1, partnerCond: item2 });
          }
        }
      }
      return mergedArray;
    },
    uzumUser() {
      return this.value.buyer_id;
    },
    uzumPeriods() {
      return this.value.available_periods;
    },
    uzumConditionals() {
      return this.partner.conditionals;
    },
    validate() {
      if (this.partner.min_amount_product > this.order.quantity_total) {
        return false;
      }
      if (this.partner.max_amount_product < this.order.quantity_total) {
        return false;
      }
      if (this.partner.max_price < this.order.price_total) {
        return false;
      }
      if (this.partner.min_price > this.order.price_total) {
        return false;
      }
      return true;
    },

    purchases: {
      get() {
        let products = [];
        if (this.order && this.order.purchases) {
          for (let i = 0; i < this.order.purchases.length; i++) {
            console.log(this.order.purchases[i]);
            for (let j = 0; j < this.order.purchases[i].quantity; j++) {
              products.push({
                amount: 1,
                product_id: this.order.purchases[i].product_id,
                price: this.order.purchases[i].price,
                name: this.order.purchases[i].name,
                imei: null,
                ikpu: this.order.purchases[i].code,
                category: this.order.purchases[i].variant ? "1331" : "12",
                is_device: this.order.purchases[i].variant ? true : false,
                unit_id: 1,
              });
            }
          }
        }
        return products;
      },
      set(value) {
        console.log(value);
      },
    },

    IMEIPurchases() {
      return this.purchases.filter((item) => item.is_device === true);
    },
  },
  props: {
    order: {
      default: function () {
        return {};
      },
    },
    partner: {
      default: function () {
        return {};
      },
    },
    createTransaction: {
      default: function () {},
    },
    transaction: {
      default: function () {},
    },
    value: {
      default: null,
    },
  },
  name: "filter",
  async mounted() {
    this.init = true;
    this.getConditions();
  },

  watch: {
    purchases: {
      handler: function () {
        this.getConditions();
      },
      deep: true,
    },
  },

  methods: {
    validateIMEI() {
      for (let i = 0; i < this.IMEIPurchases.length; i++) {
        if (
          typeof this.IMEIPurchases[i].imei != "string" ||
          this.IMEIPurchases[i].imei.length != 15
        ) {
          return false;
        }
      }
      return true;
    },
    async addOrder(limit) {
      console.log(limit);

      const products = await this.purchases;

      if (!this.validateIMEI()) {
        this.$notify({
          title: "UZUM NASIYA",
          message: "IMEI должен состоять из 15 цифр",
          type: "danger",
        });
        return false;
      }

      this.$loading(true);

      let data = {
        products: products,
        user_id: this.uzumUser,
        period: limit.cond.tariff,
        callback: `${this.$store.state.host}/api/redirect/order/${this.order.id}/${this.partner.id}`,
      };

      this.$http
        .post(
          `${this.partner["endpoint_url"]}v3/mfo/order?company_id=${this.partner.api_public_key}`,
          data,
          {
            headers: {
              Authorization: `Bearer ${this.partner["api_secret_key"]}`,
              "Content-Type": "application/json",
              Accept: "application/json",
            },
          }
        )
        .then(async (response) => {
          
          await this.createTransaction({
            api_result: JSON.stringify(response.data.data),
            exchange_id: response.data.data.paymart_client.order,
            exchange_additional_id: response.data.data.paymart_client.contract_id,
            percent: limit.partnerCond.coefficient,
            month: limit.partnerCond.month,
            step: "order-confirm",
            limit: limit.cond.balance,
          });

          this.$emit("setStep", "order-confirm");

          logger(this.$http, {
            name: "Создание заказа в #UZUM",
            description: "Начало запроса",
            model_type: "order",
            model_id: this.order.id,
            partner_id: this.partner.id,
          });
        })
        .catch((error) => {
          errorNotify(error, this.$notify);
          try {
            if (error.response.data.error && error.response.data.error.length) {
              for (let i = 0; i < error.response.data.error.length; i++)
                this.$notify({
                  title: "UZUM NASIYA",
                  message: error.response.data.error[i]["text"],
                  type: "danger",
                });
            }
          } catch (error) {}
          this.$loading(false);
        })
        .finally(async () => {});
    },
    async getConditions() {
      if (this.partnerConditionLoading == true) {
        return false;
      }

      const products = await this.purchases;

      this.partnerConditionLoading = true;
      let data = {
        products: products,
        user_id: this.uzumUser,
      };

      this.$http
        .post(
          `${this.partner["endpoint_url"]}v3/mfo/calculate?company_id=${this.partner.api_public_key}`,
          data,
          {
            headers: {
              Authorization: `Bearer ${this.partner["api_secret_key"]}`,
              "Content-Type": "application/json",
              Accept: "application/json",
            },
          }
        )
        .then(async (response) => {
          if (response.data && response.data.data) {
            this.partnerConditions = response.data.data;
          }
        })
        .catch((error) => {})
        .finally(async () => {
          this.partnerConditionLoading = false;
        });
    },
  },
  data() {
    return {
      limit: {},
      init: false,
      partnerConditions: [],
      partnerConditionLoading: false,
    };
  },
};
</script>

<style>
.conditional-selector {
  border: 1px solid #ccc;
  padding: 15px;
  margin-bottom: 15px;
  border-radius: 10px;
}
</style>

